import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { MultiSelect } from 'primeng/multiselect'
import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'basin-formly-multiselect-grouped',
  templateUrl: './formly-multiselect-grouped.component.html',
  styleUrls: ['./formly-multiselect-grouped.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyMultiselectGroupedComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  @ViewChild('multi') multi: MultiSelect
  private ngUnsubscribe = new Subject<void>()

  ngOnInit(): void {
    if (this.props && this.props.initialize) {
      this.setModel()
    }
  }

  checkIfObservable(options: Observable<any[]> | any[]) {
    return options instanceof Observable
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  setModel(): void {
    ;(this.props.options as Observable<any>)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {})
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
